// extracted by mini-css-extract-plugin
export default {"drop":"style_drop__mm0Av"};